import SummaryItemComponent, {
  SummaryItemComponentProps,
} from "../SummaryItemComponent/SummaryItemComponent";
import styles from "./SummaryTile.module.scss";
import { useTranslation } from "react-i18next";

interface SummaryTileProps {
  price: string;
  guestNumber: number;
  items?: SummaryItemComponentProps[];
}

function SummaryTile(props: SummaryTileProps) {
  const { price, guestNumber, items } = props;
  const { t } = useTranslation();
  return (
    <div className={styles.summaryTileWrapper}>
      <div className={styles.summaryTileDescriptionContainer}>
        <i className={`la-user-circle icon-xl ${styles.guestIcon}`} />
        <div className={styles.summaryTileDescriptionContent}>
          <div className={styles.summaryTilePriceAndReciept}>
            <p className={`body-medium ${styles.summaryTilePrice}`}>{price}</p>
          </div>
          <p className={`body-medium ${styles.summaryGuestDescription}`}>
            {t("billsPage.summary.guest")}
            {` - ${guestNumber}`}
          </p>
        </div>
      </div>
      {items && (
        <div className={styles.summaryTileItemsList}>
          {items.map((item, index) => (
            <SummaryItemComponent
              count={item.count}
              description={item.description}
              size={item.size}
              basePrice={item.basePrice}
              price={item.price}
              extraNote={item.extraNote}
              toppings={item.toppings}
              key={index}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default SummaryTile;
